(() => {
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  forms.forEach((form) => {
    const input = form.querySelector('[data-personalization-input]');
    const error = form.querySelector('[data-personalization-error]');
    const button = form.querySelector('[data-add-to-cart]');
    if (!input || !error || !button) return;
    form.addEventListener('submit', (event) => {
      const value = input.value.trim();
      if (!value) {
        event.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        error.hidden = false;
        error.textContent = input.dataset.personalizationErrorMessage || 'Enter a message before adding this bracelet to cart.';
        input.focus();
        return;
      }
      const disallowed = input.dataset.disallowedLetters || '';
      if (disallowed && new RegExp(`[${disallowed}]`, 'i').test(value)) {
        event.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        error.hidden = false;
        error.textContent = `${disallowed.split('').join(', ')} initials are not available for this item.`;
        input.focus();
        return;
      }
      input.value = value;
      input.removeAttribute('aria-invalid');
      error.hidden = true;
      error.textContent = '';
      button.disabled = true;
      button.textContent = 'Adding to cart…';
    });
  });
})();
